import Houdini from 'houdinijs';
import VanillaScrollspy from 'vanillajs-scrollspy';

document.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-unused-vars
  const accordion = new Houdini('[data-houdini-group="intranet-wissen"]', {
    isAccordion: true,
    collapseOthers: true,
    iconShow: '<svg><use xlink:href="#icon-arrow-down"></use></svg>',
    iconHide: '<svg><use xlink:href="#icon-arrow-down"></use></svg>',
  });

  const scrollspyElm = document.querySelectorAll('.c-intranet-wissen__nav');
  if (scrollspyElm) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < scrollspyElm.length; i++) {
      const scrollspy = new VanillaScrollspy(
        scrollspyElm[i],
        2500,
        'easeOutSine',
      );
      scrollspy.init();
    }
  }
});
